import { db, functions, storage } from '@/firebase'
import firebase from 'firebase'
import XLSX from 'xlsx';

export default {
  getCategorias({ rootState, commit }) {
    let devolver = [];
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio)
      .collection('internos').doc('categorias')
      .collection('listado').get()
      .then((r) => {
        r.forEach(c => {
          devolver.push({
            id: c.id,
            ...c.data()
          })
        });
        commit('setCategorias', devolver);
      })
  },
  addCategoria({ rootState }, c) {
    const id = c.id;
    const negocio = rootState.app.negocioGest;
    delete c.id;
    var p;
    if (id) {
      p = db.collection('negocios').doc(negocio)
        .collection('internos').doc('categorias')
        .collection('listado').doc(id).set(c, { merge: true })
    } else {
      p = db.collection('negocios').doc(negocio)
        .collection('internos').doc('categorias')
        .collection('listado').add(c);
    }
    return p;
  },
  deleteCategoria({ rootState }, c) {
    const id = c.id;
    const negocio = rootState.app.negocioGest;
    delete c.id;
    var p;
    if (id) {
      p = db.collection('negocios').doc(negocio)
        .collection('internos').doc('categorias')
        .collection('listado').doc(id).delete();
    } else {
      return Promise.reject("Fallo en la categoría")
    }
    return p;
  },
  getProductos({ rootState, commit }) {
    let devolver = [];
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio)
      .collection('internos').doc('productos')
      .collection('listado').get()
      .then((r) => {
        r.forEach(c => {
          devolver.push({
            id: c.id,
            ...c.data()
          })
        });
        commit('setProductos', devolver);
      })
  },
  addProducto({ rootState }, c) {
    const id = c.id;
    const negocio = rootState.app.negocioGest;
    delete c.id;
    var p;
    if (id) {
      p = db.collection('negocios').doc(negocio)
        .collection('internos').doc('productos')
        .collection('listado').doc(id).set(c, { merge: true })
    } else {
      p = db.collection('negocios').doc(negocio)
        .collection('internos').doc('productos')
        .collection('listado').add(c);
    }
    return p;
  },
  deleteProducto({ rootState }, c) {
    const id = c.id;
    const negocio = rootState.app.negocioGest;
    delete c.id;
    var p;
    if (id) {
      p = db.collection('negocios').doc(negocio)
        .collection('internos').doc('productos')
        .collection('listado').doc(id).delete();
    } else {
      return Promise.reject("Fallo en el producto")
    }
    return p;
  },
  getPedidosInternosRestaurante({ rootState, commit }) {
    let devolver = [];
    const negocio = rootState.app.negocioGest;
    const restaurantes = rootState.app.restauranteGest;
    var promesas = [];
    restaurantes.forEach(r => {
      promesas.push(
        db.collection('negocios').doc(negocio)
          .collection('internos').doc('pedidos')
          .collection('listado')
          .where('restaurante', '==', r).get()
          .then((int) => {
            int.forEach(p => {
              devolver.push({
                ...p.data(),
                id: p.id,
              })
            });

          })
      )
    })
    return Promise.all(promesas).then(() => {
      commit('setPedidos', devolver);
    })
  },
  getPedidosInternosNegocio({ rootState, commit }) {
    let devolver = [];
    const negocio = rootState.app.negocioGest;
    return db.collection('negocios').doc(negocio)
      .collection('internos').doc('pedidos')
      .collection('listado')
      .get()
      .then((int) => {
        int.forEach(p => {
          devolver.push({
            ...p.data(),
            id: p.id,
          })
        });
        commit('setPedidos', devolver);
      })
  },
  cambiarEstado({ rootState }, item) {
    const negocio = rootState.app.negocioGest;
    var datos = {
      estado: item.estado
    };
    if (item.estado == 'enviado') {
      datos.fechaEnviado = firebase.firestore.FieldValue.serverTimestamp();
    }

    return db.collection('negocios').doc(negocio)
      .collection('internos').doc('pedidos')
      .collection('listado')
      .doc(item.id)
      .set(datos, { merge: true })
  },
  generarExcel({ rootState }, item) {
    var excel = functions.httpsCallable('httpNegociosInternosExcel');
    return excel(item).then(function (result) {
      return result.data;
    }).catch((e) => {
      return Promise.reject(e);
    })
  },
  getExcel({ rootState }, item) {
    const filename = 'int-' + item.numPedidoInternos + '-' + negocio;
    const negocio = rootState.app.negocioGest;
    let destino = 'negocios/' + negocio + '/internos/' + filename + '.xlsx';
    var storageRef = storage.ref(destino);
    //var spaceRef = storageRef.child('imagenes/caracteristicas/' + element.id + '.jpg');
    return storageRef.getDownloadURL()

  },
  generarExcelFront({ rootState }, item) {
    const pedido = item.carritoInterno;
    const catInternas = rootState.internos.categorias;
    const impuestos = rootState.impuestos.impuestosArray
    console.log(item);
    var res = [];
    if (pedido && Array.isArray(pedido)) {
      const workbook = XLSX.utils.book_new();

      const rests = rootState.restaurantes.restaurantesArray;
      let fR = rests.find(r => r.id == item.restaurante);
      var text4 = "Restaurante";
      var text1 = "Nº Pedido";
      var text2 = "Fecha de creación";
      var text3 = "Fecha de envío";
      let datosCabecera = [{
        id: item.numPedidoInternos,
        rest: (fR) ? fR.nombre : item.restaurante,
        espera: item.fechaEspera,
        envio: item.fechaEnviado
      }
      ]
      pedido.forEach((prd) => {
        let fCat = catInternas.find((c) => c.id == prd.categoria);
        let nombreCat = fCat ? fCat.nombre : "Sin datos";
        let hojaExcel = fCat ? fCat.hojaExportar : 0;
        let fImp = impuestos.find((i) => i.id == prd.impuesto);
        let nombreImp = fImp ? fImp.nombre : "Sin datos";
        var foundHoja = res.find(r => r.hoja == hojaExcel);
        var productoAux = {
          cantidad: prd.cantidad,
          nombre: prd.nombre,
          nombreAlternativo: prd.nombreAlternativo,
          precio: prd.precio,
          nombreCat: nombreCat,
          nombreImp: nombreImp,
        }
        if (foundHoja) {
          foundHoja.productos.push(productoAux);
          foundHoja.nombre = foundHoja.nombre.indexOf(nombreCat) >= 0 ? foundHoja.nombre : foundHoja.nombre + '-' + nombreCat;
        } else {
          res.push({
            hoja: hojaExcel,
            productos: [productoAux],
            nombre: nombreCat
          });
        }
      });

      res = res.sort((a, b) => {
        return parseInt(a.hoja) - parseInt(b.hoja)
      })

      res.forEach(hoja => {
        let productos = hoja.productos.sort((a, b) => {
          if (a.nombre > b.nombre) {
            return -1;
          }
          if (b.nombre > a.nombre) {
            return 1;
          }
          return 0;
        })
        var ws = XLSX.utils.json_to_sheet(datosCabecera);
        ws['A1'].v = text1;
        ws['B1'].v = text4;
        ws['C1'].v = text2
        ws['D1'].v = text3
        var wscols = [
          { wch: 15 },
          { wch: 35 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 35 },
        ];
        ws['!cols'] = wscols;
        console.log(productos);
        XLSX.utils.sheet_add_json(ws,
          productos
          , { origin: "A4", header: ['cantidad', 'nombre', 'nombreCat', 'precio', 'nombreImp'] });

        ws['A4'].v = 'Cantidad';
        ws['B4'].v = 'Nombre'
        ws['C4'].v = 'Categoría'
        ws['D4'].v = 'Precio'
        ws['E4'].v = 'Imp.'
        ws['F4'].v = 'Nombre Alternativo.'
        ws.A4.s = { alignment: { wrapText: true, vertical: 'center', horizontal: 'center' } };

        XLSX.utils.book_append_sheet(workbook, ws, hoja.nombre.slice(0, 12))
      })
      console.log(res);
      const filename = 'int-' + item.numPedidoInternos + '-' + rootState.app.negocioGest;
      XLSX.writeFile(workbook, (`${filename}.xlsx`).slice(0, 25))
      return { ok: true }
    } else {
      return Promise.reject("No tiene productos")
    }

  }
}